import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from "@angular/core";
import { takeUntilDestroyed, toObservable } from "@angular/core/rxjs-interop";
import { UpperCasePipe } from "@angular/common";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { filter } from "rxjs";
import { EXPLORE_PAGES } from "../../core/constants/explore-pages.constants";
import { LanguageService } from "../../core/services/language.service";
import { SeoService } from "../../core/services/seo.service";
import { APP_NAME, APP_CONSTANTS } from "../../core/constants/app.constants";

@Component({
  selector: "app-explore-page",
  standalone: true,
  imports: [RouterLink, UpperCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./explore-page.component.html",
  styleUrl: "./explore-page.component.scss",
})
export class ExplorePageComponent {
  readonly appName = APP_NAME;
  private readonly route = inject(ActivatedRoute);
  private readonly seo = inject(SeoService);
  readonly language = inject(LanguageService);

  readonly page = computed(() => {
    const slug = this.route.snapshot.routeConfig?.path ?? "";
    return (
      EXPLORE_PAGES[slug]?.[this.language.language()] ?? EXPLORE_PAGES[slug]?.en
    );
  });

  constructor() {
    toObservable(this.page)
      .pipe(filter(Boolean), takeUntilDestroyed())
      .subscribe((content) => {
        this.seo.updatePage({
          title: `${content.title} | ${APP_NAME}`,
          description: content.description,
          canonical: `${APP_CONSTANTS.siteUrl}/${content.slug}/`,
        });
      });
  }
}
